import {
    ADMIN_AREA_LEVEL_ONE,
    COUNTRY,
    FILTERABLE_COUNTRY_LIST,
} from './Constants';

function termsHaveFilterableCountry(terms) {
    return terms.some((term) => FILTERABLE_COUNTRY_LIST.includes(term.value));
}

function typesHaveFilterableType(types) {
    return types.some((type) => [ADMIN_AREA_LEVEL_ONE, COUNTRY].includes(type));
}

function filterUSAPredictions(predictions) {
    return predictions
        .filter((prediction) => !termsHaveFilterableCountry(prediction.terms)
            || !typesHaveFilterableType(prediction.types));
}

export {
    filterUSAPredictions,
};
